import Main from '@/components/main/Main';

export default [
    {
        path: '/login',
        component: () => import('@/page/login/Login.vue'),
        meta: {requiresAuth: false}
    },
    {
        path: '/notFound',
        component: () => import('@/page/404/NotFound.vue'),
        meta: {requiresAuth: false}
    },
    {
        path: '/',
        redirect: '/home/dataBoard'
    },
    {
        path: '/home',
        name: 'home',
        component: Main,
        children: [
            {
                path: 'dataBoard',
                component: () => import('@/page/home/DataBoard.vue'),
                name: 'dataBoard',
                meta: {title: '首页-招考项目'}
            },
            {
                path: 'projectInfo/:id',
                component: () => import('@/page/projectInfo/Centre.vue'),
                name: 'projectInfo',
                meta: {title: '项目详情'}
            }
        ]
    },
    {
        path: '/center',
        name: 'center',
        component: Main,
        children: [
            {
                path: 'myExame',
                component: () => import('@/page/center/MyExame.vue'),
                name: 'myExame',
                meta: {title: '我的考试', requiresAuth: true}
            },
            {
                path: 'informList',
                component: () => import('@/page/center/InformList.vue'),
                name: 'informList',
                meta: {title: '我的通知', requiresAuth: true}
            }
        ]
    },
    {
        path: '/sidebar',
        name: 'sidebar',
        component: Main,
        children: [
            {
                path: 'applyPersonal',
                component: () => import('@/page/sidebar/ApplyPersonalComponent.vue'),
                name: 'applyPersonal',
                meta: {title: '报名入口', requiresAuth: true}
            },
            {
                path: 'admissionTicket',
                component: () => import('@/page/sidebar/admissionTicket/AdmissionTicketPring.vue'),
                name: 'admissionTicket',
                meta: {title: '准考证打印', requiresAuth: true}
            },
            {
                path: 'writtenScore',
                component: () => import('@/page/sidebar/scoreInquiry/WrittenScore.vue'),
                name: 'writtenScore',
                meta: {title: '笔试成绩查询', requiresAuth: true}
            },
            {
                path: 'interviewScore',
                component: () => import('@/page/sidebar/scoreInquiry/InterviewScore.vue'),
                name: 'interviewScore',
                meta: {title: '面试成绩查询', requiresAuth: true}
            },
            {
                path: 'newScore',
                component: () => import('@/page/sidebar/scoreInquiry/NewScore.vue'),
                name: 'newScore',
                meta: {title: '成绩查询', requiresAuth: true}
            }
        ]
    },
    // 任何不存在的路径的页面均会跳转至此
    {
     path: '*',
     redirect: '/notFound'
    }
]



// WEBPACK FOOTER //
// ./src/router/index.js